import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'
import { makeImgResizerUrl } from '@jelly/utils'
import { SponsoredLink } from '../SponsoredLink'
import { Link } from '@jelly/ui'

const BannerWrapper = styled(Link)`
	display: flex;
	flex-direction: column;
	height: auto;
	width: 100%;
`
const ContextWrapper = styled.div`
	display: flex;
	flex-direction: column;
	margin: auto 0;
	width: 100%;

	${({ theme }) => theme.MQ.S} {
		flex-direction: row;
		flex-wrap: wrap;
		justify-content: space-between;
	}
`
const MainContext = styled.div`
	font-size: 20px;
	color: ${({ theme }) => theme.colors.navy};
	text-align: center;
	width: fit-content;

	${({ theme }) => theme.MQ.S} {
		text-align: left;
	}

	${({ theme }) => theme.BMQ.ML} {
		text-align: center;
	}

	@media (min-width: 992px) and (max-width: 1100px) {
		text-align: center;
		margin: center;
	}

	${({ theme }) => theme.BMQ.LXL} {
		font-size: 18px;
	}
`
const Guide = styled.div`
	color: ${({ theme }) => theme.colors.orange};
	display: inline-block;
	text-decoration: underline;
`
const PresentedContext = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};

	color: ${({ theme }) => theme.colors.greyM1};
	display: flex;
	margin: auto;
	margin-bottom: 1rem;
	padding-bottom: 8px;

	${({ theme }) => theme.BMQ.SM} {
		margin-left: auto;
		margin-right: 0;
	}
`
const PartnershipDisclaimer = styled.div`
	display: inline-block;
	margin: 2px 8px 0 auto;
`
const SponsoredLogo = styled.img`
	display: inline-block;
	height: 30px;
	width: auto;
`
HubInclusionBanner.propTypes = {
	hubChannel: string,
	thumbnail: string,
	name: string,
}

/**
 * This is the HubInclusionBanner that links back to the primary channel hub page
 *
 * @param {String} props.hubChannel :: name of the primary hub channel the banner links to
 * @param {String} props.thumbnail :: image link for the hub sponsor logo
 * @param {String} props.name :: name of the hub sponsored company
 */
export function HubInclusionBanner({ hubChannel, thumbnail: logo, name, social: { website } }) {
	const sponsoredLogoSrc = makeImgResizerUrl({ src: logo, method: 'h', h: '30-png' })
	return (
		<>
			<BannerWrapper href={`/${hubChannel}/`}>
				<ContextWrapper>
					<MainContext>
						See our business.com <Guide>guide</Guide> to financial success.
					</MainContext>
				</ContextWrapper>
			</BannerWrapper>
			<PresentedContext>
				<PartnershipDisclaimer>Presented in partnership with:</PartnershipDisclaimer>
				<SponsoredLink sponsorLink={website} sponsorName={name}>
					<SponsoredLogo alt={name} className="lazyload" data-src={sponsoredLogoSrc} />
				</SponsoredLink>
			</PresentedContext>
		</>
	)
}
